import { bucketlistConstants } from "../../_constants";
const initialState = {};

// get all bucketlist reducer
export const get_all_bucket_list_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        bucketListsData: action.payload,
      };
    case bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const create_bucketlist_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        createdBucketListData: action.payload,
      };
    case bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_bucket_list_data_by_id_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_SUCCESS:
      return {
        type: "alert-success",
        bucketListByIdData: action.payload,
      };
    case bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_bucketlist_candidate_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        bucketCandidatesData: action.payload,
      };
    case bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
